import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@infra/auth/auth.service';
import { AtendimentoRepository } from '@data/atendimento/atendimento.repository';
import { AtendimentoModel } from '@data/atendimento/models';
import { AnexoRepository } from '@data/anexo/anexo.repository';
import { AnexosComponent, AnexosOptions } from '@components/anexos/anexos.component';
import { Campo, FormComponent } from '@components/form/form.component';
import { FileData } from '@components/anexos/file/file.component';
import { modal } from '@shared/alerts/modal/modal.alert';

@Component({
  selector: 'app-detalhes-atendimento',
  templateUrl: './detalhes-atendimento.component.html',
  styleUrls: ['./detalhes-atendimento.component.scss'],
})
export class DetalhesAtendimentoComponent implements AfterContentChecked {
  protected camposDadosDetalhes: Campo[] = [
    {
      name: 'numeroAtendimento',
      label: 'Número do atendimento',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'contrato.grupoContrato.numeroGrupoContrato',
      label: 'Número do grupo de contratos',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'veiculo.placa',
      label: 'Placa do veículo',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'veiculo.modelo.descricao',
      label: 'Modelo do veículo',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'descricaoOcorrido',
      label: 'Descrição do ocorrido',
      type: 'textarea',
      disabled: true,
      width: '100%',
    },
    {
      name: 'solucaoEncaminhamento',
      label: 'Solução/Encaminhamento',
      type: 'textarea',
      disabled: true,
      width: '100%',
    },
  ];

  protected camposDadosFornecedor: Campo[] = [
    {
      name: 'fornecedor.pessoa.razaoSocial',
      label: 'Nome do fornecedor',
      type: 'text',
      disabled: true,
      width: '60%',
    },
    {
      name: 'dataAgendamento',
      label: 'Data de agendamento',
      type: 'date',
      disabled: true,
      width: '40%',
    },
    {
      name: 'fornecedor.pessoa.telefone',
      label: 'Telefone',
      type: 'telefone',
      disabled: true,
      width: '40%',
    },
    {
      name: 'fornecedor.pessoa.email',
      label: 'E-mail',
      type: 'text',
      disabled: true,
      width: '60%',
    },
    {
      name: 'fornecedor.pessoa.enderecos[0].municipio.descricao',
      label: 'Cidade',
      type: 'text',
      disabled: true,
      width: '70%',
    },
    {
      name: 'fornecedor.pessoa.enderecos[0].municipio.estado',
      label: 'Estado',
      type: 'text',
      disabled: true,
      width: '30%',
    },
    {
      name: 'fornecedor.pessoa.enderecos[0].bairro',
      label: 'Bairro',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'fornecedor.pessoa.enderecos[0].logradouro',
      label: 'Logradouro',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'fornecedor.pessoa.enderecos[0].numero',
      label: 'Número',
      type: 'text',
      disabled: true,
      width: '30%',
    },
    {
      name: 'fornecedor.pessoa.enderecos[0].complemento',
      label: 'Complemento',
      type: 'text',
      disabled: true,
      width: '70%',
    },
    {
      name: 'fornecedor.observacao',
      label: 'Observação',
      type: 'textarea',
      disabled: true,
      width: '100%',
    },
  ];

  protected anexosOptions: AnexosOptions = {
    disableUpload: !this.authService.hasPermission('atendimentos', 'EDITAR'),
  }

  @ViewChild('formDetalhes') formDetalhes: FormComponent | undefined;
  @ViewChild('formFornecedor') formFornecedor: FormComponent | undefined;
  @ViewChild('anexos') anexos: AnexosComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { id: string },
    private dialogRef: MatDialogRef<DetalhesAtendimentoComponent>,
    private changeDetector: ChangeDetectorRef,
    private anexoRepository: AnexoRepository,
    private atendimentoRepository: AtendimentoRepository,
    protected authService: AuthService,
  ) {}

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngOnInit(): void {
    this.atendimentoRepository
      .getByIdRequest<{ data: AtendimentoModel }>(this.data.id)
      .subscribe(({ data }) => {
        if (data) {
          this.formDetalhes?.load(data);
          this.formFornecedor?.load(data);

          this.anexoRepository.getAnexos('AtendimentosCliente', data.id).subscribe((data) => {
            if (this.anexos) {
              this.anexos.setSentFiles(data);
            }
          });
        }
      });
  }

  protected onSubmit(anexos: FileData[]) {
    this.anexoRepository.postAnexos('AtendimentosCliente', this.data.id, anexos).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: () => {
        modal.fire({
          icon: 'error',
          title: 'Erro ao salvar anexos',
          html: 'Tente novamente mais tarde por meio dos detalhes do atendimento',
        });

        this.dialogRef.close(false);
      },
    });
  }

  protected onClose() {
    this.dialogRef.close(false);
  }
}
